import React from 'react';
import { useState, useEffect, Fragment, useRef } from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Form from 'react-bootstrap/Form';

const Approve = ({ show, handleClose, invokeCallMasterDataSave,dotloader }) => {
    const [applyImmediately, setApplyImmediately] = useState(true);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedUsecaseName, setSelectedUsecaseName] = useState(() => {
        return localStorage.getItem('selectedUsecaseName') || "";
    });
    const [selectedClientName, setSelectedClientName] = useState(() => {
        return localStorage.getItem('selectedClientName') || "";
    });
    const onApplyImmediatelyChange = (e) => {
        const checked = e.target.checked;
        setApplyImmediately(checked);

        if (checked) {
            setStartDate(null);
            setEndDate(null);

        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title>Approve</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {dotloader ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }}>
                        <div className="loader"></div>
                    </div>
                ) : (<><Form.Group as={Row} className="mb-3" controlId="usecaseSelect">
                    <Form.Label column sm="4">
                        Usecase Name<span style={{ color: 'red' }}>*</span>
                    </Form.Label>
                    <Col sm="8">
                        <Form.Select disabled size="sm" value={selectedUsecaseName}
                            onChange={(e) => setSelectedUsecaseName(e.target.value)}>
                            <option value="" disabled>Select Usecase</option>
                            <option value={selectedUsecaseName}>{selectedUsecaseName}</option>
                        </Form.Select>
                    </Col>
                </Form.Group>
                    <Form.Group as={Row} className="mb-3" controlId="clientSelect">
                        <Form.Label column sm="4">
                            Client<span style={{ color: 'red' }}>*</span>
                        </Form.Label>
                        <Col sm="8">
                            <Form.Select disabled size="sm" alue={selectedClientName}
                                onChange={(e) => setSelectedClientName(e.target.value)}>
                                <option value="" disabled>Select Client</option>
                                <option value={selectedClientName}>{selectedClientName}</option>
                            </Form.Select>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3" controlId="applyImmediately">
                        <Col sm="4" className='pe-0'>
                            <Form.Check
                                disabled
                                type="checkbox"
                                label="Apply Immediately (or)"
                                checked={applyImmediately}
                                onChange={onApplyImmediatelyChange}
                            />
                        </Col>
                        <Col sm="8">
                            <Row>
                                <Col sm={6}>
                                    <DatePicker
                                        showIcon
                                        selected={startDate}
                                        onChange={(date) => {
                                            setStartDate(date);
                                        }}
                                        isClearable
                                        placeholderText="Start Date"
                                        disabled={applyImmediately}
                                        minDate={new Date()}
                                        className='form-control'
                                    />

                                </Col>
                                <Col sm={6}>
                                    <DatePicker
                                        showIcon
                                        selected={endDate}
                                        onChange={(date) => {
                                            setEndDate(date);

                                        }}
                                        isClearable
                                        placeholderText="End Date"
                                        disabled={applyImmediately}
                                        minDate={new Date()}
                                        className='form-control'
                                    />

                                </Col>
                            </Row>
                        </Col>
                    </Form.Group></>)}
            </Modal.Body>
            {!dotloader && (<Modal.Footer>
                <Button variant="secondary" size='sm' onClick={handleClose}>
                    Decline
                </Button>
                <Button variant="primary" size='sm' onClick={invokeCallMasterDataSave}>
                    Approve
                </Button>
            </Modal.Footer>)}
        </Modal>
    )
}

export default Approve